module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-5-128.c6238b6b972e6684.jpg"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-5-128.c6238b6b972e6684.jpg",width: 128,height: 85}],
        src: "https://static.sniffspot.com/packs/img/bp-5-128.c6238b6b972e6684.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-5-128.c6238b6b972e6684.jpg"},
        
        width: 128,
        height: 85
      }